import { NavLink, useLocation } from "react-router-dom";
import "../../../styles/adminDashboard.css";
import { formatListingStatus, qualityBadgeClass } from "../../../constants/automapDealerInventoryConstants";
import {
  DUPLICATE_STATUS_LABELS,
  OUTLIER_FLAG_LABELS,
  QUALITY_ISSUE_LABELS,
  STALE_SEVERITY_CLASS,
  STALE_SEVERITY_LABELS,
} from "../../../constants/automapInventoryQualityConstants";

export {
  DUPLICATE_STATUS_LABELS,
  OUTLIER_FLAG_LABELS,
  QUALITY_ISSUE_LABELS,
  STALE_SEVERITY_CLASS,
  STALE_SEVERITY_LABELS,
  qualityBadgeClass,
  formatListingStatus,
};

export function InventoryQualityNav({ active }) {
  const items = [
    { key: "dashboard", label: "Resumen", href: "/admin/inventory-quality" },
    { key: "queue", label: "Cola priorizada", href: "/admin/inventory-quality/queue" },
    { key: "stale", label: "Obsoletos", href: "/admin/inventory-quality/stale" },
    { key: "incomplete", label: "Incompletos", href: "/admin/inventory-quality/incomplete" },
    { key: "duplicates", label: "Duplicados", href: "/admin/inventory-quality/duplicates" },
    { key: "outliers", label: "Atípicos", href: "/admin/inventory-quality/outliers" },
    { key: "dealer-followups", label: "Seguimiento dealers", href: "/admin/inventory-quality/dealer-followups" },
    { key: "rules", label: "Reglas", href: "/admin/inventory-quality/rules" },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function queueFromPathname(pathname) {
  if (pathname.includes("/stale")) return "stale";
  if (pathname.includes("/incomplete")) return "incomplete";
  if (pathname.includes("/duplicates")) return "duplicates";
  if (pathname.includes("/outliers")) return "outliers";
  if (pathname.includes("/dealer-followups")) return "dealer-followups";
  if (pathname.includes("/queue")) return "queue";
  return null;
}

export function formatCop(value) {
  if (value == null) return "—";
  return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(value);
}

export function formatDate(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("es-CO", { dateStyle: "short", timeStyle: "short" }).format(new Date(iso));
}

export function vehicleSummary(listing) {
  return [listing.year, listing.make, listing.model, listing.version].filter(Boolean).join(" ");
}

export function IssueBadges({ issues = [] }) {
  if (!issues.length) return <span className="muted">—</span>;
  return (
    <>
      {issues.slice(0, 4).map((issue) => (
        <span key={issue} className="admin-badge admin-badge--warning" style={{ marginRight: 4 }}>
          {QUALITY_ISSUE_LABELS[issue] || issue}
        </span>
      ))}
    </>
  );
}

export function ConfirmDialog({ open, title, message, onConfirm, onCancel, confirmLabel = "Confirmar" }) {
  if (!open) return null;
  return (
    <div className="admin-dialog-backdrop" role="dialog">
      <div className="admin-dialog">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="admin-console__header-actions">
          <button type="button" className="admin-btn" onClick={onCancel}>Cancelar</button>
          <button type="button" className="admin-btn admin-btn--primary" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export const QUEUE_META = {
  stale: {
    title: "Inventario obsoleto",
    description: "Listings activos sin confirmación reciente o con disponibilidad pendiente.",
    event: "inventory_stale_queue_viewed",
  },
  incomplete: {
    title: "Listings incompletos",
    description: "Vehículos con calidad baja o campos faltantes.",
    event: "inventory_incomplete_queue_viewed",
  },
  duplicates: {
    title: "Duplicados",
    description: "Candidatos a duplicado para revisión side-by-side.",
    event: "inventory_duplicates_queue_viewed",
  },
  outliers: {
    title: "Precio / kilometraje atípico",
    description: "Flags de valores sospechosos.",
    event: "inventory_outliers_queue_viewed",
  },
  "dealer-followups": {
    title: "Seguimiento a concesionarios",
    description: "Dealers con inventario obsoleto o incompleto que requieren contacto.",
    event: "inventory_followups_viewed",
  },
  queue: {
    title: "Cola priorizada",
    description: "Resumen de los issues más urgentes.",
    event: "inventory_quality_queue_viewed",
  },
};
